import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';

// What an ordinary thread stores, as published by the backend — never a literal
// here, so adding or renaming the default is a one-place change. Read it at call
// time: `app.forum` is not populated when this module is evaluated.
export function defaultDiscussionType() {
  return app.forum.attribute('defaultDiscussionType');
}

// Translated label for a single discussion_type value.
export function discussionTypeLabel(value) {
  return extractText(app.translator.trans('bhic.forum.discussion_type.' + value));
}

// Options object for the discussion-type <Select>. Every allowed value comes
// from the backend, including the one an ordinary thread carries — there is no
// blank option, because there is no blank value.
export function discussionTypeOptions() {
  const options = {};
  app.forum.attribute('discussionTypes').forEach(value => {
    options[value] = discussionTypeLabel(value);
  });
  return options;
}